<template>
  <Transition name="smi-fade">
    <div v-if="mirrorWatchers.length" class="smi" role="status" :title="`Espelho ao vivo: ${names} está vendo esta tela do sistema`">
      <span class="smi-dot"></span>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
      <span>Sua tela está sendo vista por <strong>{{ names }}</strong><template v-if="hasMarks && !mirrorMarksHidden"> · está marcando sua tela</template></span>
      <button v-if="hasMarks || mirrorMarksHidden" type="button" class="smi-btn" @click="setMirrorMarksHidden(!mirrorMarksHidden)">
        {{ mirrorMarksHidden ? 'Mostrar marcações' : 'Esconder marcações' }}
      </button>
    </div>
  </Transition>
</template>

<script setup lang="ts">
// Aviso ao agente enquanto um supervisor assiste a tela dele pelo Espelho ao vivo (transparência — LGPD).
import { computed } from 'vue'
import { mirrorWatchers, mirrorBoard, marksVersion, mirrorMarksHidden, setMirrorMarksHidden } from '@/composables/useScreenMirror'

const names = computed(() => mirrorWatchers.value.join(', '))
// marksVersion: recalcula quando chega/sai marcação (o quadro em si não é reativo).
const hasMarks = computed(() => {
  void marksVersion.value
  return mirrorBoard.marks.size > 0
})
</script>

<style scoped>
.smi {
  position: fixed; left: 16px; bottom: 16px; z-index: 8500;
  display: inline-flex; align-items: center; gap: 8px; max-width: calc(100vw - 32px);
  padding: 7px 12px; border-radius: 999px;
  background: rgba(30, 27, 75, 0.92); color: #e0e7ff; font-size: 12.5px;
  border: 1px solid rgba(165, 180, 252, 0.35); box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
  pointer-events: none;
}
.smi-btn { pointer-events: auto; margin-left: 4px; padding: 2px 9px; border-radius: 999px; border: 1px solid rgba(165, 180, 252, 0.5); background: rgba(99, 102, 241, 0.25); color: #fff; font-size: 11.5px; font-weight: 600; cursor: pointer; font-family: inherit; }
.smi-btn:hover { background: rgba(99, 102, 241, 0.45); }
.smi strong { color: #fff; font-weight: 600; }
.smi-dot { width: 7px; height: 7px; border-radius: 50%; background: #f87171; animation: smi-pulse 1.4s ease-in-out infinite; flex: none; }
@keyframes smi-pulse { 50% { opacity: 0.3; } }
.smi-fade-enter-active, .smi-fade-leave-active { transition: opacity 0.2s ease; }
.smi-fade-enter-from, .smi-fade-leave-to { opacity: 0; }
</style>
